import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteFeaturesService = async (featureId: string): Promise<void> => {
  await wbsBookingsApi.delete(`/features/${featureId}`);
};

export default deleteFeaturesService;
